import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { SitemapNode } from '../sitemap-node';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { SesionService } from '../services/sesion.service';
import { environment } from '../../environments/environment';
import { LanguageService } from '../services/language.service';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'common-headboard',
  templateUrl: './headboard.component.html',
  styleUrls: ['./headboard.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeadboardComponent extends BaseComponent implements OnInit, AfterViewInit {


  constructor(private cdr: ChangeDetectorRef, private langService: LanguageService) {
    super();
  }

  nodeSelectedTab: SitemapNode;
  nodeHeadboard: SitemapNode;
  urlBussines: string;


  openMenusOnHover: boolean;
  @ViewChild('menuPhone', { static: true }) menuPhone: ElementRef;
  loadResources(module: any): any {
    const nodeHeadboard = module.rootNode;
    this.nodeHeadboard = nodeHeadboard;
    this.selectTab();

  }

  private selectTab() {
    const indiceFichaSeleccionada = this.sesion.indiceFichaSeleccionadaCabecera$.getValue();
    this.nodeSelectedTab = this.nodeHeadboard.childNodes[indiceFichaSeleccionada];
    this.urlBussines = this.nodeHeadboard.childNodes[indiceFichaSeleccionada].url;
    this.sesion.urlBussines = this.nodeHeadboard.childNodes[1].url;
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.addSubscription(this.sesion.indiceFichaSeleccionadaCabecera$.subscribe(index => {
      this.addSubscription(this.langService.language$.subscribe(() => {
        this.addSubscription(this.langService.translationsLoaded.subscribe(async () => {
          this.nodeHeadboard = await this.langService.instantAsync('Header.rootNode').toPromise();
          this.nodeSelectedTab = this.nodeHeadboard.childNodes[index];
          this.selectTab();
        }))
      }));
    }));
  }

  ngAfterViewInit(): void {
    this.openMenusOnHover = (window.innerWidth > 990);
  }
  hasChildren(nodo: SitemapNode) {
    return nodo && typeof nodo.childNodes != 'undefined' && nodo.childNodes.length > 0;
  }
  mouseDropdown(e: MouseEvent, dropdown: BsDropdownDirective, entrando: boolean) {
    if (this.openMenusOnHover && !entrando) {
      dropdown.hide();
    }
  }
  clickMenu(nodo: SitemapNode) {
    return nodo.childNodes.length == 0;
  }

  private openMenuMobile = false;
  clickMenuMobile() {
    const menuPhone: Element = this.menuPhone.nativeElement;

    if (this.openMenuMobile) {
      menuPhone.classList.add('hidden');
    } else {
      menuPhone.classList.remove('hidden');
    }
    this.openMenuMobile = !this.openMenuMobile;
  }
}
